import { Injectable } from '@angular/core';
import { DataService } from 'app/shared/services/data.service';
import { ConfigurationService } from 'app/shared/services/configuration.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { IResult } from 'app/shared/models/result.model';
import { IDtoCatalog } from 'app/shared/models/dto-catalog.model';
import { IDtoRetroactive } from 'app/shared/models/retroactive/dto-retroactive.model';

@Injectable()
export class RetroactiveService {
  private requestUrl = '';
  constructor(private service: DataService, private configurationService: ConfigurationService) {
    if (this.configurationService.isReady) {
      this.requestUrl = this.configurationService.serverSettings.requestUrl;
    } else {
      this.configurationService.settingsLoaded$.subscribe(x => {
        this.requestUrl = this.configurationService.serverSettings.requestUrl;
      });
    }
  }
  public addRetroactive(dto: IDtoRetroactive): Observable<IResult> {
    const url = `${this.requestUrl}api/Retroactives/addRetroactive`;
    return this.service.post(url, dto).pipe(map((response: any) => {
      return response;
    }));
    }
    public addRetroactives(list: IDtoRetroactive[]): Observable<IResult> {
        const url = `${this.requestUrl}api/Retroactives/addRetroactives`;
        return this.service.post(url, list).pipe(map((response: any) => {
            return response;
        }));
    }
  public getCatalogRetroactiveReasonsByCustomerId(companyId: number): Observable<IDtoCatalog[]> {
    const url = `${this.requestUrl}api/RetroactiveReasons/getCatalogRetroactiveReasonsByCustomerId?customerId=${companyId}`;
    return this.service.get(url)
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }
  public getRetroactivesByPoriodKeyNomAndEmployeeId(periodKeyNom: Date, employeeId: number): Observable<IDtoRetroactive[]> {
    const url = `${this.requestUrl}api/Retroactives/getRetroactivesByPoriodKeyNomAndEmployeeId?periodKeyNom=${periodKeyNom}&employeeId=${employeeId}`;
    return this.service.get(url)
      .pipe(
        map((res: any) => {
          return res;
        })
      );
    }
    public getRetroactivesByPayrollId(payrollId: number): Observable<IDtoRetroactive[]> {
        const url = `${this.requestUrl}api/Retroactives/getRetroactivesByPayrollId?payrollId=${payrollId}`;
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
  public deleteRetroactive(id: number): Observable<IResult> {
    const url = `${this.requestUrl}api/Retroactives/deleteRetroactive?id=${id}`;
    return this.service.delete(url)
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }
  public getRetroactivesByPayrollIdAndBossId(payrollId: number, bossId: number): Observable<IDtoRetroactive[]> {
    const url = `${this.requestUrl}api/Retroactives/getRetroactivesByPayrollIdAndBossId?payrollId=${payrollId}&bossId=${bossId}`;
    return this.service.get(url)
        .pipe(
            map((res: any) => {
                return res;
            })
        );
}
}
